import { GetAppConfigQuery } from '@ocx/graphql';

import { OrderAheadRuntimeConfiguration } from '../app-config.types';
import { mapOrderAheadConfigurationProviderFragment } from './mapOrderAheadConfigurationProviderFragment';

export const mapOrderAheadConfiguration = (
  orderAheadConfig: GetAppConfigQuery['appConfig']['orderAhead'],
): OrderAheadRuntimeConfiguration => {
  if (!orderAheadConfig?.enabled) {
    return { enabled: false };
  }

  const provider = mapOrderAheadConfigurationProviderFragment(orderAheadConfig.provider);
  if (!provider) {
    return { enabled: false };
  }

  return {
    enabled: true,
    navbar: {
      icon: orderAheadConfig.navbar.icon,
      text: orderAheadConfig.navbar.text,
    },
    provider,
  };
};
